import React from 'react';
import './Banner.css';
import { Link } from 'react-router-dom';

function Banner() {
  return (
    <div className='banner-outer d-flex justify-content-center align-items-center flex-column'>
      <h1 className='header-text'>Get Placed</h1>
      <p className="cta-text">IN one of the top cruise lines, hotels, and airlines out there in the world. <br/> Our expert faculty can help you with it.</p>
      <button className='cta-text'><Link to='/contact'>Admission Open</Link></button>
    </div>
  )
}

export default Banner
